import { render } from "./SkillsWheelGame.vue?vue&type=template&id=5a0c9052&scoped=true"
import script from "./SkillsWheelGame.vue?vue&type=script&lang=js"
export * from "./SkillsWheelGame.vue?vue&type=script&lang=js"

import "./SkillsWheelGame.vue?vue&type=style&index=0&id=5a0c9052&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0c9052"]])

export default __exports__